import useSound from "use-sound";

let playMenuOver: () => void;
let playClicked: () => void;
let playHoverBase: (options?: { playbackRate?: number }) => void;
let playSwitchOn: () => void;
let playSwitchOff: () => void;
let playCrystalClicked: () => void;

export function useGlobalSounds(volume: number = 0){

    const [_playMenuOver] = useSound("sounds/menuOver.mp3",{ volume: volume});
    const [_playClicked] = useSound("sounds/clicked.mp3",{ volume: volume});
    const [_playHoverBase] = useSound("sounds/hover.mp3",{volume: volume});
    const [_playSwitchOn] = useSound("sounds/switchOn.mp3",{ volume: volume * 0.25});
    const [_playSwitchOff] = useSound("sounds/switchOff.mp3",{ volume: volume * 0.25});
    const [_playCrystalClicked] = useSound("sounds/crystalClicked.mp3",{ volume: volume * 0.125});
    playMenuOver = _playMenuOver;
    playClicked = _playClicked;
    playHoverBase = _playHoverBase
    playSwitchOn = _playSwitchOn
    playSwitchOff = _playSwitchOff
    playCrystalClicked = _playCrystalClicked
}

export function playHover(){
    const randomRate = 1 + (Math.floor(Math.random() * 3) - 1) / 5;
    playHoverBase({ playbackRate: randomRate });
}

export { playMenuOver, playClicked, playSwitchOn, playSwitchOff,playCrystalClicked};